import * as cx from "classnames/bind";
import * as emailValidator from "email-validator";
import s from "styles/Footer.module.scss";
import { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { ButtonLink, NavLink, Icon, Container } from "components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fetcher } from "utils";
import { useSession, useMobilePlatform } from "hooks";
import store from "store2";
import { useRouter } from "next/router";

import { useTranslation } from "next-i18next";

const Indicator = ({ ...other }) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [isBrowser, setIsBrowser] = useState(false);

  const inAppChecked = store.session.get("inAppChecked", false) || false;

  const [loaded, setLoaded] = useState(false);

  useEffect(() => setIsBrowser(true), []);

  const { locale, pathname } = useRouter();
  const horeca = pathname.startsWith("/horeca");

  return (
    <div className={cx("Indicator", s.Indicator)}>
      <div className={cx(s.IndicatorContent)}>
        <Container>
          <div>Indicator text</div>
        </Container>
      </div>
    </div>
  );
};

export default Indicator;
